const toJulianDay = (date) => {
  let year = date.getUTCFullYear();
  let month = date.getUTCMonth() + 1;
  const day = date.getUTCDate()
    + (date.getUTCHours()
      + (date.getUTCMinutes()
        + (date.getUTCSeconds() + date.getUTCMilliseconds() / 1000) / 60
      ) / 60
    ) / 24;

  if (month <= 2) {
    year -= 1;
    month += 12;
  }

  const A = Math.floor(year / 100);
  const B = 2 - A + Math.floor(A / 4);

  return Math.floor(365.25 * (year + 4716))
    + Math.floor(30.6001 * (month + 1))
    + day + B - 1524.5;
};

const fromJulianDay = (jd) => {
  const Z = Math.floor(jd + 0.5);
  const F = jd + 0.5 - Z;
  let A = Z;

  if (Z >= 2299161) {
    const alpha = Math.floor((Z - 1867216.25) / 36524.25);
    A = Z + 1 + alpha - Math.floor(alpha / 4);
  }

  const B = A + 1524;
  const C = Math.floor((B - 122.1) / 365.25);
  const D = Math.floor(365.25 * C);
  const E = Math.floor((B - D) / 30.6001);

  const day = B - D - Math.floor(30.6001 * E) + F;
  const month = E < 14 ? E - 1 : E - 13;
  const year = month > 2 ? C - 4716 : C - 4715;

  const dayInt = Math.floor(day);
  const dayFraction = day - dayInt;
  const hours = dayFraction * 24;
  const hourInt = Math.floor(hours);
  const minutes = (hours - hourInt) * 60;
  const minuteInt = Math.floor(minutes);
  const seconds = (minutes - minuteInt) * 60;
  const secondInt = Math.floor(seconds);
  const milliseconds = Math.round((seconds - secondInt) * 1000);

  return new Date(Date.UTC(year, month - 1, dayInt, hourInt, minuteInt, secondInt, milliseconds));
};

const normalizeAngle = (angle) => {
  const normalized = angle % 360;
  return normalized < 0 ? normalized + 360 : normalized;
};

const getSolarLongitude = (jd) => {
  const T = (jd - 2451545.0) / 36525;
  const T2 = T * T;
  const T3 = T2 * T;
  const L0 = 280.46646 + 36000.76983 * T + 0.0003032 * T2;
  const M = 357.52911 + 35999.05029 * T - 0.0001537 * T2 + 0.00000048 * T3;
  const Mrad = (M * Math.PI) / 180;

  const C = (1.914602 - 0.004817 * T - 0.000014 * T2) * Math.sin(Mrad)
    + (0.019993 - 0.000101 * T) * Math.sin(2 * Mrad)
    + 0.000289 * Math.sin(3 * Mrad);

  return normalizeAngle(L0 + C);
};

const isLongitudeBetween = (start, end, target) => {
  let adjustedEnd = end;
  let adjustedTarget = target;

  if (adjustedEnd < start) adjustedEnd += 360;
  if (adjustedTarget < start) adjustedTarget += 360;

  return adjustedTarget >= start && adjustedTarget <= adjustedEnd;
};

const bisectSolarLongitude = (startJd, endJd, targetLongitude, iterations = 50) => {
  let low = startJd;
  let high = endJd;
  let lowLongitude = getSolarLongitude(low);

  for (let i = 0; i < iterations; i += 1) {
    const mid = (low + high) / 2;
    const midLongitude = getSolarLongitude(mid);

    if (isLongitudeBetween(lowLongitude, midLongitude, targetLongitude)) {
      high = mid;
    } else {
      low = mid;
      lowLongitude = midLongitude;
    }
  }

  return (low + high) / 2;
};

const findSolarTermDateByYearScan = (year, targetLongitude) => {
  const jdStart = toJulianDay(new Date(Date.UTC(year, 0, 1, 0, 0, 0)));
  const jdEnd = toJulianDay(new Date(Date.UTC(year, 11, 31, 23, 59, 59)));
  let prevJd = jdStart;
  let prevLongitude = getSolarLongitude(prevJd);

  for (let jd = jdStart + 1; jd <= jdEnd + 1; jd += 1) {
    const longitude = getSolarLongitude(jd);
    if (isLongitudeBetween(prevLongitude, longitude, targetLongitude)) {
      const crossingJd = bisectSolarLongitude(prevJd, jd, targetLongitude, 30);
      return fromJulianDay(crossingJd);
    }

    prevJd = jd;
    prevLongitude = longitude;
  }

  return null;
};

export {
  bisectSolarLongitude,
  findSolarTermDateByYearScan,
  fromJulianDay,
  getSolarLongitude,
  isLongitudeBetween,
  toJulianDay
};
